import { cva } from '@/styled-system/css';

export const datePickerContentRecipe = cva({
  base: {
    display: 'flex',
    borderRadius: 'DatePicker.Content',
    flexDirection: 'column',
    backgroundColor: 'DatePicker.Content.bg',
    boxShadow: 'DatePicker.Content',
    position: 'relative',
    overflow: 'hidden',
    paddingBlock: 'DatePicker.Content.padding.vert',
    paddingInline: 'DatePicker.Content.padding.horz',
  },
  variants: {
    modal: {
      true: {
        blockSize: 'auto',
        animation: 'zoom-in 0.2s ease-out',
      },
      false: {},
    },
  },
});

export const datePickerContentPositionerRecipe = cva({
  variants: {
    modal: {
      true: {
        zIndex: 2,
      },
      false: {
        zIndex: 'datePicker',
      },
    },
  },
});
